export default "__VITE_ASSET__DIHLFdCA__"